import React, { useEffect, useState } from 'react';
import MensagemCard from "../../Components/MensagemCard";
import clsx from 'clsx';
import _ from 'lodash';
import { FuseAnimate } from "@fuse";
import { Collapse, Typography } from "@material-ui/core";
import Factory from "../../Formatadores/Factory";
import { __esModule } from "react-select";
import XAPPButton from "app/Core/Components/Button/XAPPButton";

const CentralNotificacoesResultadoPesquisa = (props) => {

    const { open = null, data = null, parametros, xappRouteParams, user, theme, locais, save, callback, getFilter, setOpenMessage, Comunicador } = props;

    const AMensagens = _.orderBy(data, "dataupt", "desc");

    return (
        <div className={clsx("flex p-12 w-full h-full overflow-hidden gap-8")}>
            <div className="w-full overflow-y-auto overflow-x-hidden">
                {AMensagens.length > 0 ? (
                    <div>
                        {AMensagens.map(item => (
                            <MensagemCard
                                data={item}
                                xappRouteParams={xappRouteParams}
                                expanded={open}
                                theme={theme}
                                parametros={parametros}
                                locais={locais}
                                save={save}
                                getFilter={getFilter}
                                showTags={parametros.idlocal !== -1}
                                callback={callback}
                                showLocal={true}
                                setOpenMessage={setOpenMessage}
                                Comunicador={Comunicador}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col flex-1 items-center justify-center p-16">
                        <div className="max-w-512 text-center">
                            <FuseAnimate delay={300}>
                                <Typography color="textSecondary" className="inline font-medium text-16 mb-16">
                                    {"Não existem registros cadastrados para essa pesquisa!"}
                                </Typography>
                            </FuseAnimate>
                        </div>
                    </div>
                )}
            </div>
            {!_.isNull(data) && !_.isNull(open) && open?.interacao === 1 &&
                <div className="flex flex-col w-3/5 border-1 p-6" style={{ "height": "65vh" }}>
                    <Factory
                        user={user}
                        xappRouteParams={xappRouteParams}
                        data={open}
                        formatador="chat"
                        save={save}
                        theme={theme}
                    />
                </div>
            }
        </div >
    );
}

export default CentralNotificacoesResultadoPesquisa;